import { createAction } from '@reduxjs/toolkit';

export const CHANGE_THEME = 'CHANGE_THEME';

export const changeTheme = createAction(CHANGE_THEME);
